// extracted by mini-css-extract-plugin
module.exports = {"right-side":"footer_right-side__Qp7ZJ","left-side":"footer_left-side__8N6pM","link":"footer_link__2VO37"};